import axios from 'axios';
import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import { Types } from '../reducers/ingestorMonitoring';

//Synchronous

//Asynchronous
export const getIngestorStatistics = () => {
  return async (dispatch) => {
    dispatch({ type: Types.SET_LOADING });

    const data = {};
    // ingestor_1: {
    //     active_sets_count: 0,
    //     active_sets: [],
    //     waiting_sets_count: 0,
    //     waiting_sets: [],
    // },
    // ingestor_2: {
    //     active_sets_count: 0,
    //     active_sets: [],
    //     waiting_sets_count: 0,
    //     waiting_sets: [],
    // }

    const bullBoardInternalAPIKey = process.env.REACT_APP_QUEUE_INTERNAL_API_KEY
    const queueSecret = process.env.REACT_APP_QUEUE_SECRET
    const authHeader = {
      headers: {
        'x-internal-api-key': bullBoardInternalAPIKey,
        Authorization: `Bearer ${queueSecret}`
      }
    }
    try {
      const getCollectionQualification = async (collectionName) => {
        console.log('param', `/${collectionName}`)
        try {
          const response = await axiosInstance.get(serverRoutes.GetCollectionQualification(`/${collectionName}`));
          return response.data.qualification;
        } catch (error) {
          console.error(`Error fetching qualification for ${collectionName}:`, error);
          return null;
        }
      };
      const processIngestorJobs = async (jobs) => {
        return Promise.all(jobs.map(async job => {
          const qualification = await getCollectionQualification(job.data.params.collectionName);
          return {
            nome_conjunto: job.data.params.collectionName,
            orgao: idToSetOrg[job.data.params.id],
            qualification
          };
        }));
      };
      const { data: serverData } = await axiosInstance.get(serverRoutes.IngestorMonitoring.getAll)
      const { idToSetOrg, consumption } = serverData

      const QUEUE_MONITORS = [
        { name: 'CallInjestor', pattern: 'CallInjestor' },
        { name: 'Datamart', pattern: 'Datamart' }, 
      ];

      const queues = await axios.get(`${process.env.REACT_APP_INTERNAL_BULLBOARD_API_URL}/api/queues?page=1&jobsPerPage=10`, authHeader);
      for (const monitor of QUEUE_MONITORS) {
        const filteredQueues = queues.data.queues.filter(queue => queue.name.includes(monitor.pattern));

        await Promise.all(filteredQueues.map(async (queue) => {
          const [activeResponse, waitingResponse] = await Promise.all([
            axios.get(`${process.env.REACT_APP_INTERNAL_BULLBOARD_API_URL}/api/queues?activeQueue=${queue.name}&status=active&page=1&jobsPerPage=100`, authHeader),
            axios.get(`${process.env.REACT_APP_INTERNAL_BULLBOARD_API_URL}/api/queues?activeQueue=${queue.name}&status=waiting&page=1&jobsPerPage=100`, authHeader)
          ]);

          const activeQueue = activeResponse.data.queues.find(q => q.name === queue.name);
          const activeJobs = await processIngestorJobs(activeQueue?.jobs || []);
          const activeJobsCount = activeQueue?.counts.active;

          const waitingQueue = waitingResponse.data.queues.find(q => q.name === queue.name);
          const waitingJobs = await processIngestorJobs(waitingQueue?.jobs || []);
          const waitingJobsCount = waitingQueue?.counts.waiting;

          data[queue.name] = {
            active_sets_count: activeJobsCount,
            active_sets: activeJobs,
            waiting_sets_count: waitingJobsCount,
            waiting_sets: waitingJobs,
          };
        }));
      }
      data.consumption = consumption;

      dispatch({
        type: Types.INGESTOR_STATISTICS,
        payload: data
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: Types.INGESTOR_STATISTICS,
        payload: null
      });
    }
  }
}